<template>
  <div class="outer-wrapper">
    <div v-if="recordInfo.display_no && toggleShow === 'operate'">
      <van-nav-bar title="原始记录" left-text="返回" left-arrow @click-left="goBack" fixed>
      </van-nav-bar>
      <van-cell :value="recordInfo.display_no" value-class="title-p" />
      <van-cell value="" value-class="sub-title-p" />
      <van-cell title="检测组" :value="recordInfo.test_category" value-class="prop-value" title-class="prop-title" />
      <van-cell title="检测时间" :value="recordInfo.create_time" value-class="prop-value" title-class="prop-title" />
      <van-cell title="关联检测信息" :value="'共' + (recordInfo.task_info.split('++').length) + '项'" value-class="prop-value"
        title-class="prop-title" />
      <div class="sample-list-wrapper">
        <div class="sample-list-inner-wrapper">
          <div v-if="recordInfo.task_info && recordInfo.task_info.split('++').length > 0" class="prop-value">
            <p v-for="(record, index) in recordInfo.task_info.split('++')" :key="index">
              <span>{{ sampleDisplayNoAbbr(record.split('|')[0]) }}</span>
              <span>({{ record.split('|')[1] }})</span>
            </p>
          </div>
          <p v-else>
            <span>无</span>
          </p>
        </div>
      </div>
      <van-cell title="状态" :value="recordInfo.upload_stat" value-class="prop-value" title-class="prop-title" />
      <van-cell title="当前原始记录照片" value-class="prop-value" title-class="prop-title" />
      <div class="d-wrapper">
        <van-uploader :before-read="handleBeforeRead" deletable :before-delete="confirmDelImg" v-model="imgList"
          capture="camera" />
      </div>
      <div class="submit-b-wrapper">
        <van-button type="warning" class="suspend-b" block @click="confirm('cancel')"
          :disabled="recordInfo.upload_stat !== '已上传'">作废记录</van-button>
        <van-button type="info" class="submit-b" block @click="confirm('recycle')"
          :disabled="recordInfo.upload_stat !== '待上传'">回收单号</van-button>
      </div>
    </div>
    <div v-else-if="!recordInfo.display_no">
      <van-empty description="该单号已回收（原始记录单号回收...）" />
    </div>
    <div class="spin" v-else>
      <van-loading type="spinner" color="#1989fa" />
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
let userToken = localStorage.getItem("current_user_token");
import { textTrans } from "@/mixins/TextTrans.js";
let authData = JSON.parse(localStorage.getItem("authData"));

import Compressor from 'compressorjs';

export default {
  name: "originRecordOp",
  components: {
  },
  mixins: [textTrans],
  props: {
    pid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      toggleShow: 'operate',
      recordInfo: {},
      imgList: [],
    };
  },
  watch: {
  },
  computed: {
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios
        .post(this.$url + "/ask_option_data", {
          userToken: userToken,
          ask_data: "originRecordImgList",
          pid: this.pid
        })
        .then(response => {
          if (response.data.stat === 'ok') {
            this.imgList = [];
            for (let i of response.data.res_record) {
              i.url = this.$fileUrlFac(i.file_url, authData.sfileRight);
              this.imgList.push(i);
            }
            this.recordInfo = response.data.recordInfo;
          } else {
            this.$toast.fail('未找到数据！');
          }
        });
    },
    confirm(sw) {
      let text;
      if (sw === 'cancel') {
        if (this.recordInfo.upload_stat !== '已上传') {
          this.$toast.fail('无法作废未上传的原始记录！');
          return '';
        }
        text = '确认作废该检测记录';
      } else if (sw === 'recycle') {
        if (this.recordInfo.upload_stat !== '待上传') {
          this.$toast.fail('无法回收已上传的原始记录单号！');
          return '';
        }
        text = '确认回收该记录单号';
      }
      this.$dialog.confirm({
        title: this.recordInfo.display_no,
        message: text,
        beforeClose: (action, done) => {
          if (action === 'confirm') {
            this.toggleShow = 'spin';
            this.$axios
              .post(this.$url + "/inspection_do", {
                userToken: userToken,
                ask_data: sw + 'Record',
                pid: this.pid
              })
              .then(response => {
                if (response.data.stat === 'ok') {
                  done();
                  this.$toast.success('操作成功！');
                  window.location.href = '/originRecord';//返回我的任务列表
                } else {
                  done();
                  this.$toast.fail('未找到数据！');
                }
              });

          } else if (action === 'cancel') {
            done();
          } else {
            done();
          }
        },
      }).catch(
        () => {
        }
      );
    },
    onClickBack() {
      this.toggleShow = 'operate';
    },
    goBack() {
      //this.$router.go(-1);
      window.location.href = '/originRecord';
    },
    handleBeforeRead(file, detail) {
      this.imgList.push({});
      if (file.size < 1024 * 200) {
        this.imgList[detail.index].obj = file;
        this.imgList[detail.index].status = "uploading";
        this.imgList[detail.index].message = "上传中...";
        this.addSubmit(detail.index);
      } else {
        let vm = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          let img = new Image();
          img.src = e.target.result;
          img.onload = function () {
            let width = 800, //图像大小
              quality = 0.7, //图像质量
              canvas = document.createElement("canvas"),
              drawer = canvas.getContext("2d");
            canvas.width = width;
            canvas.height = width * (img.height / img.width);
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
            vm.imgList[detail.index].url = canvas.toDataURL(
              "image/jpeg",
              quality
            );
            vm.imgList[detail.index].obj = vm.convertBase64UrlToFile(
              vm.imgList[detail.index].url,
              "img" + detail.index + ".jpeg"
            );
          };
        };
        new Compressor(file, {
          quality: 1024 * 200 / file.size, //压缩比例0-1
          success: (result) => {
            result = new File([result], file.name, { type: file.type, lastModified: Date.now() });//blob转file
            this.imgList[detail.index].obj = result;
            this.imgList[detail.index].status = "uploading";
            this.imgList[detail.index].message = "上传中...";
            this.addSubmit(detail.index);

          },
          error(err) {
            console.log(err.message);
          },
        });
      }

      return false;
    },
    addSubmit(index) {
      let form = new FormData();
      form.append("userToken", userToken);
      form.append("askData", 'recordUpload');
      form.append("origin_record_id", this.pid);
      form.append("imgAdded", this.imgList[index].obj);
      form.append("imgDeleted", JSON.stringify([]));
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      this.$axios
        .post(this.$url + "/inspection_do", form, config)
        .then(response => {
          console.log('replay');
          if (response.data.stat === "ok") {
            location.reload();
          } else {
            this.$toast.fail('上传失败！');
            this.imgList.splice(index, 1);
          }
        })
        .catch(error => {
          this.$toast.fail(error + "网络连接失败！");
        });
    },
    convertBase64UrlToFile(urlData, filename) {
      let arr = urlData.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    preview(item) {
      ImagePreview({ images: item.map((val) => val.static_url) });
    },
    reSet() {
      this.locationNo = '';
      this.imgList = [];
    },
    confirmDelImg(img, detail) {
      this.$dialog
        .confirm({
          title: '',
          message: "确认删除本图片？",
          beforeClose: (action, done) => {
            if (action === "confirm") {
              let form = new FormData();
              form.append("userToken", userToken);
              form.append("askData", 'recordUpload');
              form.append("origin_record_id", this.pid);
              form.append("imgDeleted", JSON.stringify([this.imgList[detail.index].id]));
              let config = {
                headers: { "Content-Type": "multipart/form-data" }
              };
              this.$axios
                .post(this.$url + "/inspection_do", form, config)
                .then(response => {
                  if (response.data.stat === "ok") {
                    this.imgList.splice(detail.index, 1);
                    done();
                  } else {
                    this.$toast.fail('删除失败！');
                  }
                })
                .catch(error => {
                  this.$toast.fail(error + "网络连接失败！");
                });
            } else if (action === "cancel") {
              done();
            } else {
              done();
            }
          },
        })
        .catch(() => { });
      return false;
    },
  }
};
</script>
<style scoped>
.title-p {
  font-weight: 700;
  font-size: 0.9rem;
  text-align: center;
}

.sub-title-p {
  text-indent: 1.2rem;
  color: #999;
}

.prop-title {
  color: #999;
  font-size: 0.4rem;
}

.prop-value {
  color: #333;
  font-size: 0.7rem;
}

.spin {
  text-align: center;
  padding-top: 40%;

}

.sample-list-wrapper {
  text-align: center;
  width: 100%;
  word-break: break-all;
}

.sample-list-inner-wrapper {
  margin: 0.5rem 0.6rem;
}

.submit-b-wrapper {
  position: fixed;
  bottom: 0;
  display: flex;
  width: 100%;
}

.submit-a-wrapper {
  position: fixed;
  bottom: 2rem;
  display: flex;
  width: 100%;
}

.suspend-b {
  width: 6rem;
}

.record-value {
  text-indent: 1rem;
}

.img-wrapper {
  width: 100%;
}

.img-wrapper img {
  width: 100%;
}

.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.6rem;
}
</style>